import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  FaPhone,
  FaMapMarkerAlt,
  FaPaperPlane,
  FaCheck,
} from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    try {
      const response = await fetch('/api/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch (err) {
      setStatus('error');
    }

    setLoading(false);
  };

  return (
    <main className="page-contact">
      <Helmet>
        <title>Contact - Devis Gratuit Site Web & Application Mobile | AGKG Créations</title>
        <meta name="description" content="Contactez AGKG Créations pour un devis gratuit. Création de sites internet et applications mobiles sur mesure. Réponse sous 24h. Béziers, Montpellier, Hérault." />
        <link rel="canonical" href="https://agkgcreations.fr/contact" />
        <meta property="og:title" content="Contact & Devis Gratuit | AGKG Créations" />
        <meta property="og:description" content="Demandez un devis gratuit pour votre site web ou application mobile. Réponse sous 24h." />
        <meta property="og:url" content="https://agkgcreations.fr/contact" />
      </Helmet>

      <section className="page-hero">
        <div className="container">
          <h1 className="section-title">
            Nous <span>contacter</span>
          </h1>
          <p className="section-subtitle">
            Un projet en tête ? Parlons-en ! Remplissez le formulaire ou contactez-nous directement.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Restons en contact</h2>
              <p>
                N'hésitez pas à nous contacter pour toute question ou demande de devis.
                Nous vous répondons sous 24h.
              </p>

              <div className="contact-methods">
                <a href="tel:+33766803300" className="contact-method">
                  <div className="contact-method-icon">
                    <FaPhone />
                  </div>
                  <div>
                    <h4>Téléphone</h4>
                    <span>07 66 80 33 00</span>
                  </div>
                </a>

                <div className="contact-method">
                  <div className="contact-method-icon">
                    <FaMapMarkerAlt />
                  </div>
                  <div>
                    <h4>Localisation</h4>
                    <span>Agde, Hérault (34)</span>
                  </div>
                </div>
              </div>

            </div>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Nom complet *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Votre nom"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="votre@email.com"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone">Téléphone</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="06 XX XX XX XX"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="subject">Sujet *</label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Sélectionnez un sujet</option>
                    <option value="site-vitrine">Site vitrine</option>
                    <option value="site-ecommerce">Site e-commerce</option>
                    <option value="application-web">Application web</option>
                    <option value="application-mobile">Application mobile</option>
                    <option value="refonte">Refonte de site</option>
                    <option value="maintenance">Maintenance</option>
                    <option value="autre">Autre</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  placeholder="Décrivez votre projet..."
                ></textarea>
              </div>

              <button
                type="submit"
                className="btn btn-primary contact-submit"
                disabled={loading}
              >
                {loading ? (
                  'Envoi en cours...'
                ) : (
                  <>
                    Envoyer le message <FaPaperPlane />
                  </>
                )}
              </button>

              {status === 'success' && (
                <div className="form-status form-success">
                  <FaCheck /> Message envoyé avec succès ! Nous vous répondrons sous 24h.
                </div>
              )}
              {status === 'error' && (
                <div className="form-status form-error">
                  Une erreur est survenue. Veuillez réessayer ou nous contacter par email.
                </div>
              )}
            </form>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
